// extracted by mini-css-extract-plugin
module.exports = {"mega-menu-prefix":"megamenu-prefix_mega-menu-prefix__skOvp"};